import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ContactActionsMobileComponent } from './contact-actions-mobile.component';

@NgModule({
	declarations: [ContactActionsMobileComponent],
	imports: [CommonModule, TranslateModule],
	exports: [ContactActionsMobileComponent],
	providers: [],
})
export class ContactActionsMobileModule {}
